import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useM } from "../useM";
import { SectionHead, Reveal } from "../ui";

const TABS = ["control", "pools", "athletes", "results"];

export const Showcase = () => {
  const m = useM();
  const [active, setActive] = useState("control");
  return (
    <section className="relative overflow-hidden border-t border-white/10 bg-mk-navy py-28 lg:py-40" data-testid="showcase-section">
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHead eyebrow={m("showcase.eyebrow")} title={m("showcase.title")} />
        <div className="mt-16 grid gap-10 lg:grid-cols-[1fr_2.2fr] lg:gap-14">
          <div className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible">
            {TABS.map((k, i) => (
              <button key={k} onClick={() => setActive(k)} data-testid={`showcase-tab-${k}`}
                className={`min-w-[220px] rounded-xl border p-5 text-left transition-[background-color,border-color] duration-300 lg:min-w-0 ${active === k ? "border-mk-yellow/50 bg-mk-yellow/[0.06]" : "border-white/10 hover:border-white/25"}`}>
                <span className={`font-mono-t text-xs ${active === k ? "text-mk-yellow" : "text-white/40"}`}>0{i + 1}</span>
                <span className="mt-2 block font-heading text-xl font-bold uppercase text-white">{m(`showcase.${k}`)}</span>
                <span className={`mt-2 block text-sm leading-relaxed text-mk-muted ${active === k ? "" : "hidden lg:block lg:opacity-60"}`}>{m(`showcase.${k}.d`)}</span>
              </button>
            ))}
          </div>
          <Reveal className="relative">
            <div className="overflow-hidden rounded-xl border border-white/10 bg-mk-bg shadow-[0_40px_120px_-30px_rgba(0,81,255,0.45)]">
              <div className="flex items-center gap-1.5 border-b border-white/10 px-4 py-3">
                {[0, 1, 2].map((d) => <span key={d} className="h-2.5 w-2.5 rounded-full bg-white/15" />)}
                <span className="ml-3 font-mono-t text-[10px] tracking-wider text-white/30">kihap.app / {m(`showcase.${active}`)}</span>
              </div>
              <div className="relative aspect-[16/10]">
                <AnimatePresence mode="wait">
                  <motion.img key={active} src={`/media/shots/${active}.jpg`} alt={m(`showcase.${active}`)} data-testid="showcase-image"
                    className="absolute inset-0 h-full w-full object-cover object-top"
                    initial={{ opacity: 0, scale: 1.02 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }} />
                </AnimatePresence>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
